import { Factory } from "@/data/dao/Factory";
import type { IDataSource, IPaginatedResult } from "@/data/dao/service/BaseServiceDao";
import { DocumentDao } from "@/data/dao/service/DocumentDao";
import { RoomDao } from "@/data/dao/service/RoomDao";
import type { IDocument } from "@/data/model/Document";
import type { IRoom } from "@/data/model/Room";
import { Format } from "@/data/util/Format";

import { BaseTabbedController } from "@/portal/controller/BaseTabbedController";
import { DocumentConditionEditor } from "@/portal/forms/DocumentConditionEditor";
import { DocumentForm } from "@/portal/forms/DocumentForm";
import { TastierGlobal } from "@/portal/globalAccess";

export class DocumentController extends BaseTabbedController<IDocument> {
    private documentForm: DocumentForm;
    private conditionEditor?: DocumentConditionEditor;

    private cachedRooms?: IPaginatedResult<IRoom>;

    constructor(element: JQuery) {
        super(element, Factory.getInstance(DocumentDao));

        this.documentForm = new DocumentForm(this.formContentByTabName("documentedit"));
        this.registerModelForm(this.documentForm);

        this.onActivateTab = (newTab) => {
            if (newTab === "conditions") this.showConditions();
        };
    }

    protected onModelLoaded(m?: IDocument) {
        if (m === undefined) {
            this.disableTabs(["conditions"]);
            const vw = $("#kt_header > #kt_header_menu_wrapper");
            if (vw.find("> .selectedlocation").length === 0)
                vw.append(
                    '<div class="selectedlocation">' +
                        Format.htmlEscape(TastierGlobal.getLocationSwitch()!.getCurrentLocationName()) +
                        "</div>"
                );
        } else this.enableTabs(["conditions"]);

        this.documentForm.setData(m);
    }

    private showConditions() {
        if (this.conditionEditor === undefined)
            this.conditionEditor = new DocumentConditionEditor(this.formContentByTabName("conditions"));

        this.conditionEditor.loadForDocument(this.entityId!, this.cachedRoomDataSource());
    }

    private cachedRoomDataSource(): IDataSource<IRoom> {
        return {
            getData: () => {
                return new Promise((r) => {
                    if (this.cachedRooms !== undefined) {
                        r(this.cachedRooms);
                        return;
                    }

                    return Factory.getInstance<RoomDao>(RoomDao)
                        .getData({ limit: 100 })
                        .then((s) => {
                            this.cachedRooms = s;
                            r(this.cachedRooms);
                        });
                });
            },
        };
    }
}
